<div class="cell-wrapper">
  <span class="cell-value">{{ value() }}</span>

  <div class="icons-container" [ngClass]="{'dropdown-icon': iconType() === 'dropdown','calendar-icon': iconType() === 'calendar'}">
    @if (iconType() && value() && hasError()) {
      @if (iconType() === 'calendar') {
        <img src="images/calendar.svg" alt="calendar" class="cell-icon">
      } @else if (iconType() === 'dropdown') {
        <img src="images/dropdown.svg" alt="calendar" class="cell-icon">
      }
    }

    <!-- Error Icon -->
    @if (hasError()) {
      <div #errorIcon class="error-icon-container" (mouseenter)="show()" (mouseleave)="hide()">
        <img src="images/notification2.svg" alt="error" class="error-icon">
      </div>
    }

  </div>
</div>

<ng-template #tooltipTemplate>
  <lib-tooltip [message]="errorMessage()"></lib-tooltip>
</ng-template>

